// Account filter configuration for different sites
// Maps site IDs to allowed account IDs for various contexts

export interface SiteAccountConfig {
  paymentAccounts: number[]; // Account IDs allowed for payment receipts
  expenseAccounts: number[]; // Account IDs allowed for expense payments
}

export interface AccountFilterConfig {
  sites: Record<number, SiteAccountConfig>;
  defaultAccounts: SiteAccountConfig;
}

// Account ID reference (from database):
// 1 = Cash Account
// 2 = Main Bank Account

export const accountFilterConfig: AccountFilterConfig = {
  sites: {},
  defaultAccounts: {
    paymentAccounts: [1, 2],
    expenseAccounts: [1, 2],
  },
};

// Helper function to get account IDs for a specific site and context
export function getAccountIdsForSite(
  siteId: number | null | undefined,
  context: 'payment' | 'expense'
): number[] {
  if (!siteId) {
    return context === 'payment' 
      ? accountFilterConfig.defaultAccounts.paymentAccounts
      : accountFilterConfig.defaultAccounts.expenseAccounts;
  }

  const siteConfig = accountFilterConfig.sites[siteId];
  if (!siteConfig) {
    return context === 'payment'
      ? accountFilterConfig.defaultAccounts.paymentAccounts
      : accountFilterConfig.defaultAccounts.expenseAccounts;
  }

  return context === 'payment' 
    ? siteConfig.paymentAccounts
    : siteConfig.expenseAccounts;
}